import React from "react";
import { motion } from "framer-motion";

export default function PiedPage() {
  return (
    <motion.footer
      className="bg-[#0f172a] text-gray-200 py-12 px-6"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-12 text-center md:text-left">
        {/* Bloc logo / description */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl font-bold text-white mb-4">
            Virtuo Systems Maroc
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed">
            L’innovation au service de votre infrastructure digitale.
            <br />
            Spécialisés en réseaux, sécurité, téléphonie IP et développement web,
            nous accompagnons les entreprises marocaines dans leur
            transformation numérique.
          </p>
        </motion.div>

        {/* Liens rapides */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <h3 className="text-lg font-semibold mb-4 text-white">Liens rapides</h3>
          <ul className="space-y-2">
            {[
              ["#accueil", "Accueil"],
              ["#apropos", "À propos"],
              ["#services", "Services"],
              ["#projets", "Projets"],
              ["#contact", "Contact"],
            ].map(([href, label]) => (
              <li key={href}>
                <a
                  href={href}
                  className="hover:text-blue-400 transition duration-200"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </motion.div>

        {/* Coordonnées */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
          <p className="text-gray-400 text-sm mb-4 leading-relaxed">
            📍 Quartier Industriel Sidi Ghanem No 208 Marrakech, Maroc <br />
            📞 +212 6 91 98 29 14 <br />
            ✉️ contact@virtuosystems.ma
          </p>

          <div className="flex justify-center md:justify-start gap-4 mt-3 text-2xl">
            <a
              href="https://www.linkedin.com/company/virtuo-system/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-blue-400 transition transform hover:scale-110"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          
         
          </div>
        </motion.div>
      </div>

      {/* Ligne de copyright */}
      <motion.div
        className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-500 text-sm"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.8 }}
      >
        © 2025 Virtuo Systems Maroc. Tous droits réservés.
      </motion.div>
    </motion.footer>
  );
}
